// Права доступа выдаёт сервер: тенант и роль живут в токене, потому что
// правила RTDB и Storage не умеют читать Firestore. Панель после входа
// просит их обновить и забирает свежий токен.
//
// Раньше claim'ы никто не ставил — их проставили вручную нескольким
// аккаунтам, а водители остались без прав и получали отказ на каждый запрос.

const FN = 'https://us-central1-godelta-partner-crm.cloudfunctions.net/syncMyClaims';

/**
 * Просит сервер выдать права и обновляет токен, если они изменились.
 *
 * @param {import('firebase/auth').User} user
 * @param {string} [companyId] подсказка для водителя, у которого карты
 *        доступа ещё нет; сервер всё равно проверяет принадлежность сам.
 * @returns {Promise<{companyId: string, role: string, driverId?: string}|null>}
 */
export const syncClaims = async (user, companyId) => {
    if (!user) return null;

    try {
        const idToken = await user.getIdToken();
        const res = await fetch(FN, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
            body: JSON.stringify(companyId ? { companyId } : {})
        });

        if (!res.ok) return null;
        const claims = await res.json();

        // Свежий токен: без этого выданные права доедут только через час,
        // когда SDK обновит его сам.
        await user.getIdToken(true);
        return claims;
    } catch (e) {
        // Сеть отвалилась — работаем на том токене, что есть.
        return null;
    }
};

/**
 * Права уже в токене? Тогда панель может рисоваться сразу, а обновление
 * прав пойдёт фоном.
 */
export const hasClaims = async (user) => {
    if (!user) return false;
    try {
        const { claims } = await user.getIdTokenResult();
        // Superadmin (właściciel produktu) NIE JEST przypisany do żadnej firmy,
        // więc warunek „companyId i role” odsyłał go po każdym wejściu do
        // ponownej synchronizacji i tak w kółko.
        return Boolean(claims.superadmin === true || (claims.companyId && claims.role));
    } catch (e) {
        return false;
    }
};

export default syncClaims;
